<header #header>
  <h2>{{ 'Stats' | translate }}</h2>
  <app-tab-select
   [items]="tabOptions"
   (change)="onStatsSectionChange($event)">
  </app-tab-select>
  <div class="teamsHeader">
    <button (click)="scrollToHome()" [class.selected]="scrolledTeam == 'home'">{{ match.home.name }}</button>
    <button (click)="scrollToVisitor()" [class.selected]="scrolledTeam == 'visitor'">{{ match.visitor.name }}</button>
  </div>
</header>
<div class="badgesWrapper" *ngIf="section.value !== 'summary'">
  <div class="team" *ngIf="match && match.home" #homeBadges>
    <h3>{{ match.home.name }}</h3>
    <ul>
      <li *ngFor="let player of playersHome">
        <app-player-badge
          [player]="player"
          [stats]="stats.stats ? stats.stats[player.id] : null"
          [bests]="stats.bests ? stats.bests : null"
          [variable]="section ? section.value : null"
          [unit]="section ? section.unit : ''">
        </app-player-badge>
      </li>
    </ul>
  </div>
  <div class="team" *ngIf="match && match.visitor" #visitorBadges>
    <h3>{{ match.visitor.name }}</h3>
    <ul>
      <li *ngFor="let player of playersVisitor">
        <app-player-badge
          [player]="player"
          [stats]="stats.stats ? stats.stats[player.id] : null"
          [bests]="stats.bests ? stats.bests : null"
          [variable]="section ? section.value : null"
          [unit]="section ? section.unit : ''">
        </app-player-badge>
      </li>
    </ul>
  </div>
</div>
<div class="summaryWrapper" *ngIf="section.value === 'summary'">
  <div class="team" *ngIf="match && match.home" #homeBadges>
    <h3>{{ match.home.name }}</h3>
    <app-shots-summary [data]="shotsStatsHome"></app-shots-summary>
    <div class="dataWrapper">
      <app-summary-table
        class="table home scrollbox"
        [data]="rowsHome">
      </app-summary-table>
    </div>
  </div>

  <div class="team" *ngIf="match && match.visitor" #visitorBadges>
    <h3>{{ match.visitor.name }}</h3>
    <app-shots-summary [data]="shotsStatsVisitor"></app-shots-summary>
    <div class="dataWrapper">
      <app-summary-table
        class="table visitor scrollbox"
        [data]="rowsVisitor">
      </app-summary-table>
    </div>
  </div>
</div>
